function setEndOfDayBackendString(date: Date | null): string | null {
    if (!date) {
        return null;
    }

    const modDate = new Date(date);

    modDate.setHours(23);
    modDate.setMinutes(59);
    modDate.setSeconds(59);
    modDate.setMilliseconds(999);

    return modDate.toISOString().replace('Z', '');
}

function setStartOfDayToBackendString(date: Date | null): string | null {
    if (!date) {
        return null;
    }

    const modDate = new Date(date);

    modDate.setHours(0);
    modDate.setMinutes(0);
    modDate.setSeconds(0);
    modDate.setMilliseconds(0);

    return modDate.toISOString().replace('Z', '');
}

function isEqualJsDate(date1: Date | null, date2: Date | null): boolean {
    if (date1 === null && date2 === null) {
        return true;
    }
    if (date1 === null || date2 === null) {
        return false;
    }
    return date1.getTime() === date2.getTime();
}

export const DateHelper = {
    setEndOfDayBackendString,
    setStartOfDayToBackendString,
    isEqualJsDate,
};
